import React from "react";
import Toolbar from "@material-ui/core/Toolbar";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const PaginationToolBar = (props) => {
  const { handlePageChange, currentPage, totalPages } = props;

  return (
      <Toolbar
        style={{
          backgroundColor: "white",
          color: "grey",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }} >
        <span
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage == 1}
          style={{border: '1px solid #D3D3D3',  padding: '7px', display: 'flex', alignItems: "center", cursor: "pointer"}}
        >
          <ChevronLeftIcon />
          Previous
        </span>
        {[...Array(totalPages)].map((_, index) => (
          <span
            key={index + 1}
            style={{
              cursor: "pointer",
              fontWeight: currentPage === index ? "bold" : "normal",
              border: '1px solid #D3D3D3',
              padding: '10px 15px 10px 15px'
            }}
            onClick={() => handlePageChange(index)}
          >
            {index + 1}
          </span>
        ))}
        <span onClick={() => handlePageChange(currentPage + 1)}
              style={{border: '1px solid #D3D3D3', padding: '7px', display: 'flex', alignItems: "center", cursor: "pointer"}}>
          Next
          <ChevronRightIcon disabled={currentPage == totalPages - 1} />
        </span>
      </Toolbar>
  );
};

export default PaginationToolBar;
